import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatINR(n: number | null | undefined): string {
  if (n == null) return "₹0";
  return "₹" + n.toLocaleString("en-IN");
}

// Numeric value of a roll number ("10" -> 10). Non-numeric roll numbers sort last.
export function rollNumber(v: unknown): number {
  const d = String(v ?? "").replace(/\D/g, "");
  return d ? parseInt(d, 10) : Number.MAX_SAFE_INTEGER;
}

// Comparator that orders rows by roll_no numerically (1,2,...,10,11), name as tiebreak.
export function byRollNo<T extends { roll_no?: string | null; name?: string | null; student_name?: string | null }>(a: T, b: T): number {
  return (
    rollNumber(a.roll_no) - rollNumber(b.roll_no) ||
    String(a.name ?? a.student_name ?? "").localeCompare(String(b.name ?? b.student_name ?? ""))
  );
}

